<!--test.vue-->
<template>
  <div class="qk-video">
    <video :src="videoSrc" :loop="loop" :autoplay="autoPlay" :muted="muted" :ref="refId"></video>
  </div>
</template>

<script>
	export default {
		name: 'QkVideo', // 这个名字很重要，它就是未来的标签名<qk-text></qk-text>
		props: {
			videoSrc: {
				type: String,
        default: 'https://sct-ieds.oss-cn-shenzhen.aliyuncs.com/h5-show/sct/entry/v3/entry_pc.mp4'
      },
			loop: {
				type: Boolean,
        default: false
      },
			muted: {
				type: Boolean,
        default: false
      },
			autoPlay: {
				type: Boolean,
        default: false
      }
		},
    data(){
      return {
        refId: new Date().getTime() + '_video'
      }
    },
    created(){
      console.log(this.display, 'created !!')
    },
    methods: {
      play(){
        this.$refs[this.refId].play();
      },
    },
	}
</script>

<style lang="scss" scoped>
  .qk-video{
    width: 100%;
    height: 100%;
  }
  video{
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
    outline: 0;
    padding: 0;
    margin: 0;
  }
</style>
